import { useAppSelector } from '@hook/index';
import * as React from 'react';
import { Helmet } from 'react-helmet';
export interface ISEOProps {
  data?: any;
  noindex?: boolean;
}

const FALLBACK_TITLE = 'Đại lý VIVA88VIET';
const FALLBACK_DESC =
  'Hệ thống đại lý VIVA88VIET: đăng ký làm đại lý, hoa hồng đến 1,75% mỗi tuần, quản lý tài khoản cá cược và giao dịch điểm.';

/** Query strings never change the content of a page here, so keep them out of canonical URLs. */
const canonicalUrl = () => {
  if (typeof window === 'undefined') return '';
  return window.location.origin + window.location.pathname;
};

export default function SEO({ data, noindex }: ISEOProps) {
  const { data: dataSetting } = useAppSelector((state) => state.settingSlice);
  const setting = dataSetting?.listSetting;

  const title = data?.seo_title || data?.title || setting?.seo_title || FALLBACK_TITLE;
  const description = data?.seo_description || setting?.seo_description || FALLBACK_DESC;
  const keywords = data?.tags || data?.seo_keywords || setting?.seo_keywords || '';
  const image = data?.image || data?.thumbail || data?.icon || setting?.logo || '';
  const url = canonicalUrl();

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : <meta name="dc.language" content="vi" />}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      )}

      <meta property="og:type" content="website" />
      <meta property="og:locale" content="vi_VN" />
      <meta property="og:site_name" content={FALLBACK_TITLE} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:url" content={url} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
